import { NgFor } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { FormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MaskitoDirective } from '@maskito/angular';
import { MatDialog } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';
import { CondicaoQualidadeStateService, EtapasDeEdicaoService } from '../../services';
import { mask_porcentagem_limpa } from '../../directives/mascaras';
import { TabelaComponent } from '../../shared/tabela/tabela.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MenuSuspensoComponent } from '../../shared/menu-suspenso/menu-suspenso.component';
import { PQRManutencaoFormacaoMaterialDto } from '../../dtos/pqr-manutencao-formacao-material.dto';
import { DialogPqrManutencaoDasEscolasComponent } from '../../shared/dialog-pqr-manutencao-das-escolas/dialog-pqr-manutencao-das-escolas.component';
import { ValidacaoResult, ValidadorTela } from '../../interfaces/validacao.interface';
import { BasePqrComponent } from '../base-pqr/base-pqr.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-manutencao-das-escolas',
  standalone: true,
  imports: [
    NgFor,
    MatIcon,
    FormsModule,
    TabelaComponent,
    MaskitoDirective,
    MatTooltipModule,
    MenuSuspensoComponent,
    DialogPqrManutencaoDasEscolasComponent
  ],
  templateUrl: './manutencao-das-escolas.component.html',
  styleUrl: './manutencao-das-escolas.component.scss'
})
export class ManutencaoDasEscolasComponent extends BasePqrComponent<PQRManutencaoFormacaoMaterialDto> implements OnInit, ValidadorTela {

  protected valoresPadrao: PQRManutencaoFormacaoMaterialDto[] = [];
  protected valoresEdicao: PQRManutencaoFormacaoMaterialDto[] = [];

  public get despesasDepartamentais(): PQRManutencaoFormacaoMaterialDto[] {
    return this.valoresEdicao;
  }
  public set despesasDepartamentais(value: PQRManutencaoFormacaoMaterialDto[]) {
    this.valoresEdicao = value;
  }

  public get tooltipVisivel(): boolean {
    return this.menuTooltipVisible;
  }

  public abrirTooltips(): void {
    this.openTooltips();
  }

  public fecharTooltips(): void {
    this.closeTooltips();
  }

  totalDespesasDepartamentais = 0;
  mask_porcentagem_limpa = mask_porcentagem_limpa;

  constructor(
    router: Router,
    toastr: ToastrService,
    dialogRestaurarValores: MatDialog,
    private dialogPqrManutencaoDasEscolas: MatDialog,
    private etapasDeEdicaoService: EtapasDeEdicaoService,
    private condicaoQualidadeStateService: CondicaoQualidadeStateService,
  ) {
    super(router, toastr, dialogRestaurarValores, dialogPqrManutencaoDasEscolas);
  }

  ngOnInit(): void {
    this.etapasDeEdicaoService.setOpcaoAtual(14);
    this.carregarDadosInterno();
  }

  private carregarDadosInterno() {
    this.carregarDados(
      () => this.condicaoQualidadeStateService.getPQRManutencaoFormacaoMaterialPadrao(),
      () => this.condicaoQualidadeStateService.getPQRManutencaoFormacaoMaterialValores()
    );
    this.atualizarDados();
  }

  adicionarDespesa(): void {
    this.despesasDepartamentais.push({
      id: this.despesasDepartamentais.length + 1,
      codPqrAdicionaisManutencaoEncargos: this.despesasDepartamentais.length + 1,
      descricaoItem: '',
      percentual: 0,
      tipoCategoriaItem: {
        codTipoCategoriaItem: 2,
        descricao: 'Manutenção das escolas, formação, materiais didáticos e outros'
      }
    });
  }

  removerDespesa(index: number): void {
    this.despesasDepartamentais.splice(index, 1);
    this.atualizarDados();
  }

  atualizarDados(): void {
    let total = 0;

    this.despesasDepartamentais.forEach((despesa) => {
      despesa.percentual = Number(String(despesa.percentual).split(',').join('.'));
      total += despesa.percentual;
    });

    this.totalDespesasDepartamentais = Math.round(total * 10) / 10;
    this.atualizarValores();
  }

  protected atualizarValores() {
    this.condicaoQualidadeStateService.setPQRManutencaoFormacaoMaterialValores(this.despesasDepartamentais);
  }

  protected openDialogPqrValoresPadrao(): void {
    const dialogRef = this.dialogPqrManutencaoDasEscolas.open(
      DialogPqrManutencaoDasEscolasComponent,
      {
        panelClass: 'dialog-pqr-manutencao-das-escolas',
      },
    );

    dialogRef.componentInstance.dados =
      this.condicaoQualidadeStateService.getPQRManutencaoFormacaoMaterialPadrao();
  }

  public criaMensagemInconsistencia(): string[] {
    const mensagens: string[] = [];
    this.despesasDepartamentais.forEach((despesa, index) => {
      if (!despesa.descricaoItem || despesa.descricaoItem.trim() === '') {
        mensagens.push(
          `A descrição da sequência ${index + 1} não foi informada.`,
        );
      }

      // Verifica se o percentual foi informado
      if (despesa.percentual === null || despesa.percentual === undefined || String(despesa.percentual).trim() === '') {
        mensagens.push(
          `O percentual da sequência ${index + 1} não foi informado.`,
        );
      } else {
        // Só valida se o percentual estiver dentro da faixa
        const percentual = Number(String(despesa.percentual).replace(',', '.'));
        if (percentual < 0 || percentual > 100) {
          mensagens.push(
            `O percentual da sequência ${index + 1} deve estar entre 0 e 100.`,
          );
        }
      }
    });

    return mensagens;
  }
}
